// extracted by mini-css-extract-plugin
export default {"TaskSection":"_1-+JzQ9jUIKCU1-5v6uT2w=="};